export enum SonoraHintType {
    GhostText = 1,
    TeachingBubble = 2,
}
